import * as actionTypes from '../action-types'

export const updateNewPurpose = payload => {
  return {
    type: actionTypes.UPDATE_NEW_AGREEMENT,
    payload
  }
}

export const resetNewPurpose = () => {
  return {
    type: actionTypes.RESET_NEW_AGREEMENT
  }
}

export const updateSelectedPurpose = payload => {
  return {
    type: actionTypes.UPDATE_SELECTED_AGREEMENT,
    payload
  }
}

export const resetSelectedPurpose = () => {
  return {
    type: actionTypes.RESET_SELECTED_AGREEMENT
  }
}

export const updateSelectedRefs = payload => {
  return {
    type: actionTypes.UPDATE_SELECTED_REFS,
    payload
  }
}

export const resetSelectedRefs = payload => {
  return {
    type: actionTypes.RESET_SELECTED_REFS
  }
}

export const updatePurposesList = payload => {
  return {
    type: actionTypes.UPDATE_PURPOSES_LIST,
    payload
  }
}

export const updatePurposeTableSort = payload => {
  return {
    type: actionTypes.UPDATE_AGREEMENT_TABLE_SORT,
    payload
  }
}



// WEBPACK FOOTER //
// ./src/redux-store/actions/purpose-actions.js